// ewiSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quarterList: [],
  selectedQuarter: null,
};

const ewiSlice = createSlice({
  name: "ewi",
  initialState,
  reducers: {
    setQuarterList: (state, action) => {
      state.quarterList = action.payload;
    },
    setSelectedQuarter: (state, action) => {
      state.selectedQuarter = action.payload;
    },
    resetSelectedQuarter: (state, action) => {
      return initialState;
    },
  },
});

export const { setQuarterList, setSelectedQuarter, resetSelectedQuarter } =
  ewiSlice.actions;
export default ewiSlice.reducer;
